export enum SORTING_OPTIONS_TRIPLE_PLAY {
  Year_Price = 0,
  Month_Price = 1,
  Testscore = 2,
  TV_Channels = 3,
  Speed = 4,
}

export const SORTING_DESCENDING_ORDER_TRIPLE_PLAY = {
  [SORTING_OPTIONS_TRIPLE_PLAY.Year_Price]: false,
  [SORTING_OPTIONS_TRIPLE_PLAY.Month_Price]: false,
  [SORTING_OPTIONS_TRIPLE_PLAY.Testscore]: true,
  [SORTING_OPTIONS_TRIPLE_PLAY.TV_Channels]: true,
  [SORTING_OPTIONS_TRIPLE_PLAY.Speed]: true,
};

export const SORTING_REFERENCE_TRIPLE_PLAY = {
  [SORTING_OPTIONS_TRIPLE_PLAY.Year_Price]: 'priceInfo.initialDiscounted',
  [SORTING_OPTIONS_TRIPLE_PLAY.Month_Price]: 'priceInfo.total',
  [SORTING_OPTIONS_TRIPLE_PLAY.Testscore]: 'testScore',
  [SORTING_OPTIONS_TRIPLE_PLAY.TV_Channels]:
    'servicesWrapper.televisionInfo.channels.numberOfTvChannels',
  [SORTING_OPTIONS_TRIPLE_PLAY.Speed]:
    'servicesWrapper.networkInformation.internetSpeed.downloadSpeedInMb',
};
